import { combineReducers, configureStore } from '@reduxjs/toolkit';
import projectPreviewReducer from './pages/projects/preview/store/ProjectPreviewReducer';

const rootReducer = combineReducers({
  preview: projectPreviewReducer,
});

export const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
